import { Button, Tooltip } from 'antd'
import { ImagePlus } from 'lucide-react'
import { BulkImageUploadDrawer } from './BulkImageUploadDrawer'
import { useFFEStore } from '../../../store/ffeStore'

export const BulkImageUploadButton = () => {
  const isBulkImageDrawerOpen = useFFEStore(
    (state) => state.isBulkImageDrawerOpen
  )
  const setIsBulkImageDrawerOpen = useFFEStore(
    (state) => state.setIsBulkImageDrawerOpen
  )
  return (
    <>
      <Tooltip title="Upload multiple images to create line items automatically">
        <Button
          icon={<ImagePlus className="h-4 w-4" />}
          onClick={() => setIsBulkImageDrawerOpen(true)}
          block
        >
          Bulk Image Upload
        </Button>
      </Tooltip>

      <BulkImageUploadDrawer
        open={isBulkImageDrawerOpen}
        onClose={() => setIsBulkImageDrawerOpen(false)}
      />
    </>
  )
}
